// This file is auto-generated by @hey-api/openapi-ts

import type { Options as ClientOptions, TDataShape, Client } from './client';
import type { AuthControllerInitiateSignupData, AuthControllerInitiateSignupResponses, AuthControllerCompleteSignupData, AuthControllerCompleteSignupResponses, AuthControllerLoginData, AuthControllerLoginResponses, AuthControllerLogoutData, AuthControllerLogoutResponses, AuthControllerIsAuthenticatedData, AuthControllerIsAuthenticatedResponses, AuthControllerInitiatePasswordResetData, AuthControllerInitiatePasswordResetResponses, AuthControllerCompletePasswordResetData, AuthControllerCompletePasswordResetResponses, AuthControllerGoogleAuthData, AuthControllerGoogleAuthResponses, AuthControllerGoogleAuthCallbackData, AuthControllerGoogleAuthCallbackResponses, AuthControllerGoogleAppAuthData, AuthControllerGoogleAppAuthResponses, AuthControllerGoogleAppAuthCallbackData, AuthControllerGoogleAppAuthCallbackResponses, AuthControllerVerifyTokenData, AuthControllerVerifyTokenResponses, UserControllerFindAllByOrganizationData, UserControllerFindAllByOrganizationResponses, UserControllerSearchUsersData, UserControllerSearchUsersResponses, UserControllerRemoveData, UserControllerRemoveResponses, UserControllerFindOneData, UserControllerFindOneResponses, UserControllerUpdateData, UserControllerUpdateResponses, OrganizationControllerFindByIdData, OrganizationControllerFindByIdResponses, OrganizationControllerUpdateData, OrganizationControllerUpdateResponses, OrganizationControllerCreateData, OrganizationControllerCreateResponses, OrganizationControllerFindAllData, OrganizationControllerFindAllResponses, OrganizationControllerRemoveAdminData, OrganizationControllerRemoveAdminResponses, OrganizationControllerUpdateAdminRoleData, OrganizationControllerUpdateAdminRoleResponses, ConsentControllerCreateData, ConsentControllerCreateResponses, SessionControllerGetCurrentSessionData, SessionControllerGetCurrentSessionResponses, SessionControllerGetAllSessionsData, SessionControllerGetAllSessionsResponses, SessionControllerDestroySessionData, SessionControllerDestroySessionResponses, SessionControllerDestroyAllSessionsData, SessionControllerDestroyAllSessionsResponses, EmailControllerPreviewEmailData, EmailControllerPreviewEmailResponses, CardTemplateControllerCreateData, CardTemplateControllerCreateResponses, CardTemplateControllerRemoveData, CardTemplateControllerRemoveResponses, CardTemplateControllerUpdateData, CardTemplateControllerUpdateResponses, CommunicationControllerFindAllData, CommunicationControllerFindAllResponses, CommunicationControllerCreateData, CommunicationControllerCreateResponses, CommunicationControllerDeleteData, CommunicationControllerDeleteResponses, CommunicationControllerFindOneData, CommunicationControllerFindOneResponses, CommunicationControllerUpdateData, CommunicationControllerUpdateResponses, TargetGroupControllerFindAllData, TargetGroupControllerFindAllResponses, TargetGroupControllerCreateData, TargetGroupControllerCreateResponses, TargetGroupControllerRemoveData, TargetGroupControllerRemoveResponses, TargetGroupControllerFindOneData, TargetGroupControllerFindOneResponses, TargetGroupControllerUpdateData, TargetGroupControllerUpdateResponses, TargetGroupControllerPreviewData, TargetGroupControllerPreviewResponses, LoyaltyCardInstanceControllerFindAllByUserData, LoyaltyCardInstanceControllerFindAllByUserResponses, LoyaltyCardInstanceControllerCreateData, LoyaltyCardInstanceControllerCreateResponses, LoyaltyCardInstanceControllerRemoveData, LoyaltyCardInstanceControllerRemoveResponses, LoyaltyCardInstanceControllerUpdateData, LoyaltyCardInstanceControllerUpdateResponses, LoyaltyCardInstanceControllerCreateInstanceData, LoyaltyCardInstanceControllerCreateInstanceResponses, LoyaltyCardControllerCreateData, LoyaltyCardControllerCreateResponses, LoyaltyCardControllerDeleteData, LoyaltyCardControllerDeleteResponses, LoyaltyCardControllerFindAllStampCardsData, LoyaltyCardControllerFindAllStampCardsResponses, LoyaltyCardControllerFindStampCardsInRangeData, LoyaltyCardControllerFindStampCardsInRangeResponses, LoyaltyCardControllerFindOneStampCardData, LoyaltyCardControllerFindOneStampCardResponses, LoyaltyCardControllerUpdateStampCardData, LoyaltyCardControllerUpdateStampCardResponses, LoyaltyCardControllerFindAllPointCardsData, LoyaltyCardControllerFindAllPointCardsResponses, LoyaltyCardControllerFindAllGiftCardsData, LoyaltyCardControllerFindAllGiftCardsResponses, TransactionControllerCreateData, TransactionControllerCreateResponses, TransactionControllerFindByUserIdData, TransactionControllerFindByUserIdResponses, TransactionControllerRemoveData, TransactionControllerRemoveResponses, TransactionControllerFindOneData, TransactionControllerFindOneResponses, TransactionControllerUpdateData, TransactionControllerUpdateResponses, RewardControllerFindAllData, RewardControllerFindAllResponses, RewardControllerCreateData, RewardControllerCreateResponses, RewardControllerRemoveData, RewardControllerRemoveResponses, RewardControllerFindOneData, RewardControllerFindOneResponses, RewardControllerUpdateData, RewardControllerUpdateResponses, RewardMilestoneControllerCreateData, RewardMilestoneControllerCreateResponses, RewardMilestoneControllerFindByStampCardData, RewardMilestoneControllerFindByStampCardResponses, RewardMilestoneControllerFindByLoyaltyProgramData, RewardMilestoneControllerFindByLoyaltyProgramResponses, RewardMilestoneControllerRemoveData, RewardMilestoneControllerRemoveResponses, RewardMilestoneControllerFindOneData, RewardMilestoneControllerFindOneResponses, RewardMilestoneControllerUpdateData, RewardMilestoneControllerUpdateResponses, LoyaltyProgramControllerCreateData, LoyaltyProgramControllerCreateResponses, LoyaltyProgramControllerFindByOrganizationData, LoyaltyProgramControllerFindByOrganizationResponses, LoyaltyProgramControllerRemoveData, LoyaltyProgramControllerRemoveResponses, LoyaltyProgramControllerFindOneData, LoyaltyProgramControllerFindOneResponses, LoyaltyProgramControllerUpdateData, LoyaltyProgramControllerUpdateResponses, UserRewardControllerFindByUserData, UserRewardControllerFindByUserResponses, SubscriptionControllerGetActiveSubscriptionData, SubscriptionControllerGetActiveSubscriptionResponses, SubscriptionControllerCreateCheckoutLinkData, SubscriptionControllerCreateCheckoutLinkResponses, SubscriptionControllerCancelSubscriptionData, SubscriptionControllerCancelSubscriptionResponses, SubscriptionControllerGetSubscriptionHistoryData, SubscriptionControllerGetSubscriptionHistoryResponses, SubscriptionControllerCreateCustomerPortalSessionData, SubscriptionControllerCreateCustomerPortalSessionResponses, SubscriptionPlanControllerFindAllData, SubscriptionPlanControllerFindAllResponses, SubscriptionPlanControllerCreateData, SubscriptionPlanControllerCreateResponses, SubscriptionPlanControllerRemoveData, SubscriptionPlanControllerRemoveResponses, SubscriptionPlanControllerFindOneData, SubscriptionPlanControllerFindOneResponses, SubscriptionPlanControllerUpdateData, SubscriptionPlanControllerUpdateResponses, PaddleControllerHandleWebhookData, PaddleControllerHandleWebhookResponses, HealthControllerCheckHealthData, HealthControllerCheckHealthResponses, HealthControllerCheckHealthErrors, HealthControllerCheckDbData, HealthControllerCheckDbResponses, HealthControllerCheckDbErrors, HealthControllerCheckDiskData, HealthControllerCheckDiskResponses, HealthControllerCheckDiskErrors, HealthControllerCheckMemoryData, HealthControllerCheckMemoryResponses, HealthControllerCheckMemoryErrors, InvitationControllerGetPendingForUserData, InvitationControllerGetPendingForUserResponses, InvitationControllerGetByOrganizationData, InvitationControllerGetByOrganizationResponses, InvitationControllerCreateData, InvitationControllerCreateResponses, InvitationControllerRescindData, InvitationControllerRescindResponses, InvitationControllerUpdateStatusData, InvitationControllerUpdateStatusResponses, LoyaltyLevelControllerFindAllData, LoyaltyLevelControllerFindAllResponses, LoyaltyLevelControllerCreateData, LoyaltyLevelControllerCreateResponses, LoyaltyLevelControllerRemoveData, LoyaltyLevelControllerRemoveResponses, LoyaltyLevelControllerUpdateData, LoyaltyLevelControllerUpdateResponses, QrCodeControllerFindAllData, QrCodeControllerFindAllResponses, QrCodeControllerCreateQrCodeData, QrCodeControllerCreateQrCodeResponses, QrCodeControllerGenerateIdentityImageData, QrCodeControllerGenerateIdentityImageResponses, QrCodeControllerGenerateIdentityPayloadData, QrCodeControllerGenerateIdentityPayloadResponses, QrCodeControllerIdentifyUserData, QrCodeControllerIdentifyUserResponses, QrCodeControllerProcessActionByIdentityData, QrCodeControllerProcessActionByIdentityResponses, QrCodeControllerGenerateRewardImageData, QrCodeControllerGenerateRewardImageResponses, QrCodeControllerGenerateRewardPayloadData, QrCodeControllerGenerateRewardPayloadResponses, QrCodeControllerRedeemRewardData, QrCodeControllerRedeemRewardResponses, SeedControllerSeedData, SeedControllerSeedResponses, SeedControllerSeedErrors, SeedControllerClearAllDataData, SeedControllerClearAllDataResponses, SeedControllerClearAllDataErrors, StatisticsControllerGetStatisticsData, StatisticsControllerGetStatisticsResponses, UserCommunicationControllerGetStatisticsByCommunicationIdData, UserCommunicationControllerGetStatisticsByCommunicationIdResponses, UserCommunicationControllerSearchUserCommunicationsData, UserCommunicationControllerSearchUserCommunicationsResponses, UserCommunicationControllerSearchInAppUserCommunicationsData, UserCommunicationControllerSearchInAppUserCommunicationsResponses, UserCommunicationControllerMarkInAppUserCommunicationAsReadData, UserCommunicationControllerMarkInAppUserCommunicationAsReadResponses, UserCommunicationControllerGetInAppUnreadCountData, UserCommunicationControllerGetInAppUnreadCountResponses, UserCommunicationControllerGetOrganizationConversationsOverviewData, UserCommunicationControllerGetOrganizationConversationsOverviewResponses, WaitlistControllerCreateData, WaitlistControllerCreateResponses, WaitlistControllerGetCountData, WaitlistControllerGetCountResponses } from './types.gen';
import { client as _heyApiClient } from './client.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

export const authControllerInitiateSignup = <ThrowOnError extends boolean = false>(options: Options<AuthControllerInitiateSignupData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AuthControllerInitiateSignupResponses, unknown, ThrowOnError>({
        url: '/auth/signup',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const authControllerCompleteSignup = <ThrowOnError extends boolean = false>(options: Options<AuthControllerCompleteSignupData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AuthControllerCompleteSignupResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/auth/complete-signup',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const authControllerLogin = <ThrowOnError extends boolean = false>(options: Options<AuthControllerLoginData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AuthControllerLoginResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/auth/login',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const authControllerLogout = <ThrowOnError extends boolean = false>(options?: Options<AuthControllerLogoutData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<AuthControllerLogoutResponses, unknown, ThrowOnError>({
        url: '/auth/logout',
        ...options
    });
};

export const authControllerIsAuthenticated = <ThrowOnError extends boolean = false>(options?: Options<AuthControllerIsAuthenticatedData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AuthControllerIsAuthenticatedResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/auth/is-authenticated',
        ...options
    });
};

export const authControllerInitiatePasswordReset = <ThrowOnError extends boolean = false>(options: Options<AuthControllerInitiatePasswordResetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AuthControllerInitiatePasswordResetResponses, unknown, ThrowOnError>({
        url: '/auth/reset-password',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const authControllerCompletePasswordReset = <ThrowOnError extends boolean = false>(options: Options<AuthControllerCompletePasswordResetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AuthControllerCompletePasswordResetResponses, unknown, ThrowOnError>({
        url: '/auth/complete-reset-password',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const authControllerGoogleAuth = <ThrowOnError extends boolean = false>(options?: Options<AuthControllerGoogleAuthData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AuthControllerGoogleAuthResponses, unknown, ThrowOnError>({
        url: '/auth/google',
        ...options
    });
};

export const authControllerGoogleAuthCallback = <ThrowOnError extends boolean = false>(options?: Options<AuthControllerGoogleAuthCallbackData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AuthControllerGoogleAuthCallbackResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/auth/google/callback',
        ...options
    });
};

export const authControllerGoogleAppAuth = <ThrowOnError extends boolean = false>(options?: Options<AuthControllerGoogleAppAuthData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AuthControllerGoogleAppAuthResponses, unknown, ThrowOnError>({
        url: '/auth/google-app',
        ...options
    });
};

export const authControllerGoogleAppAuthCallback = <ThrowOnError extends boolean = false>(options?: Options<AuthControllerGoogleAppAuthCallbackData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<AuthControllerGoogleAppAuthCallbackResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/auth/google-app/callback',
        ...options
    });
};

export const authControllerVerifyToken = <ThrowOnError extends boolean = false>(options: Options<AuthControllerVerifyTokenData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<AuthControllerVerifyTokenResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/auth/google/verify-token',
        ...options
    });
};

export const userControllerFindAllByOrganization = <ThrowOnError extends boolean = false>(options: Options<UserControllerFindAllByOrganizationData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<UserControllerFindAllByOrganizationResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/user',
        ...options
    });
};

export const userControllerSearchUsers = <ThrowOnError extends boolean = false>(options: Options<UserControllerSearchUsersData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<UserControllerSearchUsersResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/user/search',
        ...options
    });
};

export const userControllerRemove = <ThrowOnError extends boolean = false>(options: Options<UserControllerRemoveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<UserControllerRemoveResponses, unknown, ThrowOnError>({
        url: '/user/{userId}',
        ...options
    });
};

export const userControllerFindOne = <ThrowOnError extends boolean = false>(options: Options<UserControllerFindOneData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<UserControllerFindOneResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/user/{userId}',
        ...options
    });
};

export const userControllerUpdate = <ThrowOnError extends boolean = false>(options: Options<UserControllerUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UserControllerUpdateResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/user/{userId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const organizationControllerFindById = <ThrowOnError extends boolean = false>(options: Options<OrganizationControllerFindByIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<OrganizationControllerFindByIdResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/organization',
        ...options
    });
};

export const organizationControllerUpdate = <ThrowOnError extends boolean = false>(options: Options<OrganizationControllerUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<OrganizationControllerUpdateResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/organization',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const organizationControllerCreate = <ThrowOnError extends boolean = false>(options: Options<OrganizationControllerCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<OrganizationControllerCreateResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/organization',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const organizationControllerFindAll = <ThrowOnError extends boolean = false>(options?: Options<OrganizationControllerFindAllData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<OrganizationControllerFindAllResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/organization/all',
        ...options
    });
};

export const organizationControllerRemoveAdmin = <ThrowOnError extends boolean = false>(options: Options<OrganizationControllerRemoveAdminData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<OrganizationControllerRemoveAdminResponses, unknown, ThrowOnError>({
        url: '/organization/admin/{userId}',
        ...options
    });
};

export const organizationControllerUpdateAdminRole = <ThrowOnError extends boolean = false>(options: Options<OrganizationControllerUpdateAdminRoleData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<OrganizationControllerUpdateAdminRoleResponses, unknown, ThrowOnError>({
        url: '/organization/admin/{userId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const consentControllerCreate = <ThrowOnError extends boolean = false>(options: Options<ConsentControllerCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ConsentControllerCreateResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/consent',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const sessionControllerGetCurrentSession = <ThrowOnError extends boolean = false>(options?: Options<SessionControllerGetCurrentSessionData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<SessionControllerGetCurrentSessionResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/session/current',
        ...options
    });
};

export const sessionControllerGetAllSessions = <ThrowOnError extends boolean = false>(options?: Options<SessionControllerGetAllSessionsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<SessionControllerGetAllSessionsResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/session/all',
        ...options
    });
};

export const sessionControllerDestroySession = <ThrowOnError extends boolean = false>(options: Options<SessionControllerDestroySessionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<SessionControllerDestroySessionResponses, unknown, ThrowOnError>({
        url: '/session/destroy/{sessionId}',
        ...options
    });
};

export const sessionControllerDestroyAllSessions = <ThrowOnError extends boolean = false>(options?: Options<SessionControllerDestroyAllSessionsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).delete<SessionControllerDestroyAllSessionsResponses, unknown, ThrowOnError>({
        url: '/session/destroy-all',
        ...options
    });
};

export const emailControllerPreviewEmail = <ThrowOnError extends boolean = false>(options: Options<EmailControllerPreviewEmailData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<EmailControllerPreviewEmailResponses, unknown, ThrowOnError>({
        url: '/email/preview',
        ...options
    });
};

export const cardTemplateControllerCreate = <ThrowOnError extends boolean = false>(options: Options<CardTemplateControllerCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CardTemplateControllerCreateResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/card-template',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const cardTemplateControllerRemove = <ThrowOnError extends boolean = false>(options: Options<CardTemplateControllerRemoveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<CardTemplateControllerRemoveResponses, unknown, ThrowOnError>({
        url: '/card-template/{id}',
        ...options
    });
};

export const cardTemplateControllerUpdate = <ThrowOnError extends boolean = false>(options: Options<CardTemplateControllerUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<CardTemplateControllerUpdateResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/card-template/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const communicationControllerFindAll = <ThrowOnError extends boolean = false>(options: Options<CommunicationControllerFindAllData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<CommunicationControllerFindAllResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/communication',
        ...options
    });
};

export const communicationControllerCreate = <ThrowOnError extends boolean = false>(options: Options<CommunicationControllerCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CommunicationControllerCreateResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/communication',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const communicationControllerDelete = <ThrowOnError extends boolean = false>(options: Options<CommunicationControllerDeleteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<CommunicationControllerDeleteResponses, unknown, ThrowOnError>({
        url: '/communication/{communicationId}',
        ...options
    });
};

export const communicationControllerFindOne = <ThrowOnError extends boolean = false>(options: Options<CommunicationControllerFindOneData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<CommunicationControllerFindOneResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/communication/{communicationId}',
        ...options
    });
};

export const communicationControllerUpdate = <ThrowOnError extends boolean = false>(options: Options<CommunicationControllerUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<CommunicationControllerUpdateResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/communication/{communicationId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const targetGroupControllerFindAll = <ThrowOnError extends boolean = false>(options: Options<TargetGroupControllerFindAllData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<TargetGroupControllerFindAllResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/target-group',
        ...options
    });
};

export const targetGroupControllerCreate = <ThrowOnError extends boolean = false>(options: Options<TargetGroupControllerCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<TargetGroupControllerCreateResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/target-group',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const targetGroupControllerRemove = <ThrowOnError extends boolean = false>(options: Options<TargetGroupControllerRemoveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<TargetGroupControllerRemoveResponses, unknown, ThrowOnError>({
        url: '/target-group/{id}',
        ...options
    });
};

export const targetGroupControllerFindOne = <ThrowOnError extends boolean = false>(options: Options<TargetGroupControllerFindOneData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<TargetGroupControllerFindOneResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/target-group/{id}',
        ...options
    });
};

export const targetGroupControllerUpdate = <ThrowOnError extends boolean = false>(options: Options<TargetGroupControllerUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<TargetGroupControllerUpdateResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/target-group/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const targetGroupControllerPreview = <ThrowOnError extends boolean = false>(options: Options<TargetGroupControllerPreviewData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<TargetGroupControllerPreviewResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/target-group/preview',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const loyaltyCardInstanceControllerFindAllByUser = <ThrowOnError extends boolean = false>(options?: Options<LoyaltyCardInstanceControllerFindAllByUserData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<LoyaltyCardInstanceControllerFindAllByUserResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/loyalty-card-instance',
        ...options
    });
};

export const loyaltyCardInstanceControllerCreate = <ThrowOnError extends boolean = false>(options: Options<LoyaltyCardInstanceControllerCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<LoyaltyCardInstanceControllerCreateResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/loyalty-card-instance',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const loyaltyCardInstanceControllerRemove = <ThrowOnError extends boolean = false>(options: Options<LoyaltyCardInstanceControllerRemoveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<LoyaltyCardInstanceControllerRemoveResponses, unknown, ThrowOnError>({
        url: '/loyalty-card-instance/{id}',
        ...options
    });
};

export const loyaltyCardInstanceControllerUpdate = <ThrowOnError extends boolean = false>(options: Options<LoyaltyCardInstanceControllerUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<LoyaltyCardInstanceControllerUpdateResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/loyalty-card-instance/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const loyaltyCardInstanceControllerCreateInstance = <ThrowOnError extends boolean = false>(options: Options<LoyaltyCardInstanceControllerCreateInstanceData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<LoyaltyCardInstanceControllerCreateInstanceResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/loyalty-card-instance/user',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const loyaltyCardControllerCreate = <ThrowOnError extends boolean = false>(options: Options<LoyaltyCardControllerCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<LoyaltyCardControllerCreateResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/loyalty-card',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const loyaltyCardControllerDelete = <ThrowOnError extends boolean = false>(options: Options<LoyaltyCardControllerDeleteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<LoyaltyCardControllerDeleteResponses, unknown, ThrowOnError>({
        url: '/loyalty-card/{id}',
        ...options
    });
};

export const loyaltyCardControllerFindAllStampCards = <ThrowOnError extends boolean = false>(options: Options<LoyaltyCardControllerFindAllStampCardsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<LoyaltyCardControllerFindAllStampCardsResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/loyalty-card/stamp-cards',
        ...options
    });
};

export const loyaltyCardControllerFindStampCardsInRange = <ThrowOnError extends boolean = false>(options: Options<LoyaltyCardControllerFindStampCardsInRangeData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<LoyaltyCardControllerFindStampCardsInRangeResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/loyalty-card/stamp-cards/in-range',
        ...options
    });
};

export const loyaltyCardControllerFindOneStampCard = <ThrowOnError extends boolean = false>(options: Options<LoyaltyCardControllerFindOneStampCardData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<LoyaltyCardControllerFindOneStampCardResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/loyalty-card/stamp-cards/{id}',
        ...options
    });
};

export const loyaltyCardControllerUpdateStampCard = <ThrowOnError extends boolean = false>(options: Options<LoyaltyCardControllerUpdateStampCardData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<LoyaltyCardControllerUpdateStampCardResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/loyalty-card/stamp-cards/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const loyaltyCardControllerFindAllPointCards = <ThrowOnError extends boolean = false>(options: Options<LoyaltyCardControllerFindAllPointCardsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<LoyaltyCardControllerFindAllPointCardsResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/loyalty-card/point-cards',
        ...options
    });
};

export const loyaltyCardControllerFindAllGiftCards = <ThrowOnError extends boolean = false>(options: Options<LoyaltyCardControllerFindAllGiftCardsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<LoyaltyCardControllerFindAllGiftCardsResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/loyalty-card/gift-cards',
        ...options
    });
};

export const transactionControllerCreate = <ThrowOnError extends boolean = false>(options: Options<TransactionControllerCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<TransactionControllerCreateResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/transaction',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const transactionControllerFindByUserId = <ThrowOnError extends boolean = false>(options: Options<TransactionControllerFindByUserIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<TransactionControllerFindByUserIdResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/transaction/search',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const transactionControllerRemove = <ThrowOnError extends boolean = false>(options: Options<TransactionControllerRemoveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<TransactionControllerRemoveResponses, unknown, ThrowOnError>({
        url: '/transaction/{id}',
        ...options
    });
};

export const transactionControllerFindOne = <ThrowOnError extends boolean = false>(options: Options<TransactionControllerFindOneData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<TransactionControllerFindOneResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/transaction/{id}',
        ...options
    });
};

export const transactionControllerUpdate = <ThrowOnError extends boolean = false>(options: Options<TransactionControllerUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<TransactionControllerUpdateResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/transaction/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const rewardControllerFindAll = <ThrowOnError extends boolean = false>(options: Options<RewardControllerFindAllData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<RewardControllerFindAllResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/reward',
        ...options
    });
};

export const rewardControllerCreate = <ThrowOnError extends boolean = false>(options: Options<RewardControllerCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<RewardControllerCreateResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/reward',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const rewardControllerRemove = <ThrowOnError extends boolean = false>(options: Options<RewardControllerRemoveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<RewardControllerRemoveResponses, unknown, ThrowOnError>({
        url: '/reward/{id}',
        ...options
    });
};

export const rewardControllerFindOne = <ThrowOnError extends boolean = false>(options: Options<RewardControllerFindOneData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<RewardControllerFindOneResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/reward/{id}',
        ...options
    });
};

export const rewardControllerUpdate = <ThrowOnError extends boolean = false>(options: Options<RewardControllerUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<RewardControllerUpdateResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/reward/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const rewardMilestoneControllerCreate = <ThrowOnError extends boolean = false>(options: Options<RewardMilestoneControllerCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<RewardMilestoneControllerCreateResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/reward-milestone',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const rewardMilestoneControllerFindByStampCard = <ThrowOnError extends boolean = false>(options: Options<RewardMilestoneControllerFindByStampCardData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<RewardMilestoneControllerFindByStampCardResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/reward-milestone/stamp-card/{stampCardId}',
        ...options
    });
};

export const rewardMilestoneControllerFindByLoyaltyProgram = <ThrowOnError extends boolean = false>(options: Options<RewardMilestoneControllerFindByLoyaltyProgramData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<RewardMilestoneControllerFindByLoyaltyProgramResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/reward-milestone/loyalty-program/{loyaltyProgramId}',
        ...options
    });
};

export const rewardMilestoneControllerRemove = <ThrowOnError extends boolean = false>(options: Options<RewardMilestoneControllerRemoveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<RewardMilestoneControllerRemoveResponses, unknown, ThrowOnError>({
        url: '/reward-milestone/{id}',
        ...options
    });
};

export const rewardMilestoneControllerFindOne = <ThrowOnError extends boolean = false>(options: Options<RewardMilestoneControllerFindOneData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<RewardMilestoneControllerFindOneResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/reward-milestone/{id}',
        ...options
    });
};

export const rewardMilestoneControllerUpdate = <ThrowOnError extends boolean = false>(options: Options<RewardMilestoneControllerUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<RewardMilestoneControllerUpdateResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/reward-milestone/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const loyaltyProgramControllerCreate = <ThrowOnError extends boolean = false>(options: Options<LoyaltyProgramControllerCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<LoyaltyProgramControllerCreateResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/loyalty-program',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const loyaltyProgramControllerFindByOrganization = <ThrowOnError extends boolean = false>(options: Options<LoyaltyProgramControllerFindByOrganizationData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<LoyaltyProgramControllerFindByOrganizationResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/loyalty-program/by-organization',
        ...options
    });
};

export const loyaltyProgramControllerRemove = <ThrowOnError extends boolean = false>(options: Options<LoyaltyProgramControllerRemoveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<LoyaltyProgramControllerRemoveResponses, unknown, ThrowOnError>({
        url: '/loyalty-program/{id}',
        ...options
    });
};

export const loyaltyProgramControllerFindOne = <ThrowOnError extends boolean = false>(options: Options<LoyaltyProgramControllerFindOneData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<LoyaltyProgramControllerFindOneResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/loyalty-program/{id}',
        ...options
    });
};

export const loyaltyProgramControllerUpdate = <ThrowOnError extends boolean = false>(options: Options<LoyaltyProgramControllerUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<LoyaltyProgramControllerUpdateResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/loyalty-program/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const userRewardControllerFindByUser = <ThrowOnError extends boolean = false>(options?: Options<UserRewardControllerFindByUserData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<UserRewardControllerFindByUserResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/',
        ...options
    });
};

export const subscriptionControllerGetActiveSubscription = <ThrowOnError extends boolean = false>(options: Options<SubscriptionControllerGetActiveSubscriptionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<SubscriptionControllerGetActiveSubscriptionResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/subscription',
        ...options
    });
};

export const subscriptionControllerCreateCheckoutLink = <ThrowOnError extends boolean = false>(options: Options<SubscriptionControllerCreateCheckoutLinkData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SubscriptionControllerCreateCheckoutLinkResponses, unknown, ThrowOnError>({
        url: '/subscription/checkout',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const subscriptionControllerCancelSubscription = <ThrowOnError extends boolean = false>(options: Options<SubscriptionControllerCancelSubscriptionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SubscriptionControllerCancelSubscriptionResponses, unknown, ThrowOnError>({
        url: '/subscription/cancel',
        ...options
    });
};

export const subscriptionControllerGetSubscriptionHistory = <ThrowOnError extends boolean = false>(options: Options<SubscriptionControllerGetSubscriptionHistoryData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<SubscriptionControllerGetSubscriptionHistoryResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/subscription/history',
        ...options
    });
};

export const subscriptionControllerCreateCustomerPortalSession = <ThrowOnError extends boolean = false>(options: Options<SubscriptionControllerCreateCustomerPortalSessionData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<SubscriptionControllerCreateCustomerPortalSessionResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/subscription/portal-session',
        ...options
    });
};

export const subscriptionPlanControllerFindAll = <ThrowOnError extends boolean = false>(options?: Options<SubscriptionPlanControllerFindAllData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<SubscriptionPlanControllerFindAllResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/subscription-plan',
        ...options
    });
};

export const subscriptionPlanControllerCreate = <ThrowOnError extends boolean = false>(options: Options<SubscriptionPlanControllerCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SubscriptionPlanControllerCreateResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/subscription-plan',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const subscriptionPlanControllerRemove = <ThrowOnError extends boolean = false>(options: Options<SubscriptionPlanControllerRemoveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<SubscriptionPlanControllerRemoveResponses, unknown, ThrowOnError>({
        url: '/subscription-plan/{id}',
        ...options
    });
};

export const subscriptionPlanControllerFindOne = <ThrowOnError extends boolean = false>(options: Options<SubscriptionPlanControllerFindOneData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<SubscriptionPlanControllerFindOneResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/subscription-plan/{id}',
        ...options
    });
};

export const subscriptionPlanControllerUpdate = <ThrowOnError extends boolean = false>(options: Options<SubscriptionPlanControllerUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<SubscriptionPlanControllerUpdateResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/subscription-plan/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const paddleControllerHandleWebhook = <ThrowOnError extends boolean = false>(options: Options<PaddleControllerHandleWebhookData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PaddleControllerHandleWebhookResponses, unknown, ThrowOnError>({
        url: '/paddle/webhook',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const healthControllerCheckHealth = <ThrowOnError extends boolean = false>(options?: Options<HealthControllerCheckHealthData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<HealthControllerCheckHealthResponses, HealthControllerCheckHealthErrors, ThrowOnError>({
        responseType: 'json',
        url: '/health',
        ...options
    });
};

export const healthControllerCheckDb = <ThrowOnError extends boolean = false>(options?: Options<HealthControllerCheckDbData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<HealthControllerCheckDbResponses, HealthControllerCheckDbErrors, ThrowOnError>({
        responseType: 'json',
        url: '/health/db',
        ...options
    });
};

export const healthControllerCheckDisk = <ThrowOnError extends boolean = false>(options?: Options<HealthControllerCheckDiskData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<HealthControllerCheckDiskResponses, HealthControllerCheckDiskErrors, ThrowOnError>({
        responseType: 'json',
        url: '/health/disk',
        ...options
    });
};

export const healthControllerCheckMemory = <ThrowOnError extends boolean = false>(options?: Options<HealthControllerCheckMemoryData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<HealthControllerCheckMemoryResponses, HealthControllerCheckMemoryErrors, ThrowOnError>({
        responseType: 'json',
        url: '/health/memory',
        ...options
    });
};

export const invitationControllerGetPendingForUser = <ThrowOnError extends boolean = false>(options?: Options<InvitationControllerGetPendingForUserData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<InvitationControllerGetPendingForUserResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/invitation/pending',
        ...options
    });
};

export const invitationControllerGetByOrganization = <ThrowOnError extends boolean = false>(options: Options<InvitationControllerGetByOrganizationData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<InvitationControllerGetByOrganizationResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/invitation/by-organization',
        ...options
    });
};

export const invitationControllerCreate = <ThrowOnError extends boolean = false>(options: Options<InvitationControllerCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<InvitationControllerCreateResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/invitation',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const invitationControllerRescind = <ThrowOnError extends boolean = false>(options: Options<InvitationControllerRescindData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<InvitationControllerRescindResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/invitation/{invitationId}',
        ...options
    });
};

export const invitationControllerUpdateStatus = <ThrowOnError extends boolean = false>(options: Options<InvitationControllerUpdateStatusData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<InvitationControllerUpdateStatusResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/invitation/{invitationId}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const loyaltyLevelControllerFindAll = <ThrowOnError extends boolean = false>(options: Options<LoyaltyLevelControllerFindAllData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<LoyaltyLevelControllerFindAllResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/loyalty-level',
        ...options
    });
};

export const loyaltyLevelControllerCreate = <ThrowOnError extends boolean = false>(options: Options<LoyaltyLevelControllerCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<LoyaltyLevelControllerCreateResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/loyalty-level',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const loyaltyLevelControllerRemove = <ThrowOnError extends boolean = false>(options: Options<LoyaltyLevelControllerRemoveData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<LoyaltyLevelControllerRemoveResponses, unknown, ThrowOnError>({
        url: '/loyalty-level/{id}',
        ...options
    });
};

export const loyaltyLevelControllerUpdate = <ThrowOnError extends boolean = false>(options: Options<LoyaltyLevelControllerUpdateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<LoyaltyLevelControllerUpdateResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/loyalty-level/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const qrCodeControllerFindAll = <ThrowOnError extends boolean = false>(options: Options<QrCodeControllerFindAllData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<QrCodeControllerFindAllResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/qrcode',
        ...options
    });
};

export const qrCodeControllerCreateQrCode = <ThrowOnError extends boolean = false>(options: Options<QrCodeControllerCreateQrCodeData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<QrCodeControllerCreateQrCodeResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/qrcode',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const qrCodeControllerGenerateIdentityImage = <ThrowOnError extends boolean = false>(options?: Options<QrCodeControllerGenerateIdentityImageData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<QrCodeControllerGenerateIdentityImageResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/qrcode/identity/generate-image',
        ...options
    });
};

export const qrCodeControllerGenerateIdentityPayload = <ThrowOnError extends boolean = false>(options?: Options<QrCodeControllerGenerateIdentityPayloadData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<QrCodeControllerGenerateIdentityPayloadResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/qrcode/identity/generate-payload',
        ...options
    });
};

export const qrCodeControllerIdentifyUser = <ThrowOnError extends boolean = false>(options: Options<QrCodeControllerIdentifyUserData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<QrCodeControllerIdentifyUserResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/qrcode/identity/identify',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const qrCodeControllerProcessActionByIdentity = <ThrowOnError extends boolean = false>(options: Options<QrCodeControllerProcessActionByIdentityData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<QrCodeControllerProcessActionByIdentityResponses, unknown, ThrowOnError>({
        url: '/qrcode/action/process-by-identity',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const qrCodeControllerGenerateRewardImage = <ThrowOnError extends boolean = false>(options: Options<QrCodeControllerGenerateRewardImageData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<QrCodeControllerGenerateRewardImageResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/qrcode/reward/generate-image',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const qrCodeControllerGenerateRewardPayload = <ThrowOnError extends boolean = false>(options: Options<QrCodeControllerGenerateRewardPayloadData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<QrCodeControllerGenerateRewardPayloadResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/qrcode/reward/generate-payload',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const qrCodeControllerRedeemReward = <ThrowOnError extends boolean = false>(options: Options<QrCodeControllerRedeemRewardData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<QrCodeControllerRedeemRewardResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/qrcode/reward/redeem',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Seed the database with test data
 */
export const seedControllerSeed = <ThrowOnError extends boolean = false>(options?: Options<SeedControllerSeedData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<SeedControllerSeedResponses, SeedControllerSeedErrors, ThrowOnError>({
        url: '/seed',
        ...options
    });
};

/**
 * Clear all data from the database
 */
export const seedControllerClearAllData = <ThrowOnError extends boolean = false>(options?: Options<SeedControllerClearAllDataData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<SeedControllerClearAllDataResponses, SeedControllerClearAllDataErrors, ThrowOnError>({
        url: '/seed/clear',
        ...options
    });
};

export const statisticsControllerGetStatistics = <ThrowOnError extends boolean = false>(options: Options<StatisticsControllerGetStatisticsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<StatisticsControllerGetStatisticsResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/statistics',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const userCommunicationControllerGetStatisticsByCommunicationId = <ThrowOnError extends boolean = false>(options: Options<UserCommunicationControllerGetStatisticsByCommunicationIdData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<UserCommunicationControllerGetStatisticsByCommunicationIdResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/user-communication/statistics/{communicationId}',
        ...options
    });
};

export const userCommunicationControllerSearchUserCommunications = <ThrowOnError extends boolean = false>(options: Options<UserCommunicationControllerSearchUserCommunicationsData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<UserCommunicationControllerSearchUserCommunicationsResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/user-communication/search',
        ...options
    });
};

export const userCommunicationControllerSearchInAppUserCommunications = <ThrowOnError extends boolean = false>(options?: Options<UserCommunicationControllerSearchInAppUserCommunicationsData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<UserCommunicationControllerSearchInAppUserCommunicationsResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/user-communication/in-app/search',
        ...options
    });
};

export const userCommunicationControllerMarkInAppUserCommunicationAsRead = <ThrowOnError extends boolean = false>(options: Options<UserCommunicationControllerMarkInAppUserCommunicationAsReadData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UserCommunicationControllerMarkInAppUserCommunicationAsReadResponses, unknown, ThrowOnError>({
        url: '/user-communication/in-app/{userCommunicationId}/mark-read',
        ...options
    });
};

export const userCommunicationControllerGetInAppUnreadCount = <ThrowOnError extends boolean = false>(options?: Options<UserCommunicationControllerGetInAppUnreadCountData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<UserCommunicationControllerGetInAppUnreadCountResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/user-communication/in-app/unread-count',
        ...options
    });
};

export const userCommunicationControllerGetOrganizationConversationsOverview = <ThrowOnError extends boolean = false>(options?: Options<UserCommunicationControllerGetOrganizationConversationsOverviewData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<UserCommunicationControllerGetOrganizationConversationsOverviewResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/user-communication/in-app/organization-conversations',
        ...options
    });
};

export const waitlistControllerCreate = <ThrowOnError extends boolean = false>(options: Options<WaitlistControllerCreateData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<WaitlistControllerCreateResponses, unknown, ThrowOnError>({
        url: '/waitlist',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

export const waitlistControllerGetCount = <ThrowOnError extends boolean = false>(options?: Options<WaitlistControllerGetCountData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<WaitlistControllerGetCountResponses, unknown, ThrowOnError>({
        responseType: 'json',
        url: '/waitlist/count',
        ...options
    });
};